import { SubtractButtonView } from 'components'

export default SubtractButtonView
